import { Center, Heading, Spinner } from "@reverb-ui/react";
import React, { useContext, useEffect } from "react";
import { useParams } from "react-router";
import { AuthContext } from "../context-api/providers/auth";
var Cockpit = function () {
    var emailToSimulate = useParams().emailToSimulate;
    var _a = useContext(AuthContext), loginWithCockpit = _a.loginWithCockpit, errorSimulatingAccount = _a.errorSimulatingAccount, isLoggedIn = _a.isLoggedIn;
    useEffect(function () {
        if (!emailToSimulate || !isLoggedIn)
            return;
        loginWithCockpit(emailToSimulate).then(function () {
            window.location.href = "/";
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emailToSimulate, isLoggedIn]);
    if (errorSimulatingAccount)
        return (React.createElement(Center, { h: "100vh", w: "100vw" },
            React.createElement(Heading, { fontSize: "xl", color: "gray.700" }, errorSimulatingAccount.message)));
    return (React.createElement(Center, { h: "100vh", w: "100vw" },
        React.createElement(Spinner, { color: "blue.500", size: "md" })));
};
export default Cockpit;
